import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { ConstanteService } from '../../../_services/constante.service';
import { Constante } from '../../../_models/constante';

@Injectable()
export class AdmsbConstanteCacheService extends ConstanteService {
  private cachePorCodigo = new Map<string, Observable<Constante>>();

  getByCode(code: string): Observable<Constante> {
    if (!this.cachePorCodigo.has(code)) {
      this.cachePorCodigo.set(code, super.getByCode(code).pipe(
        tap({ error: () => this.cachePorCodigo.delete(code) }),
        shareReplay(1),
      ));
    }
    return this.cachePorCodigo.get(code);
  }
}
